// src/contexts/ClientModalContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog } from '@mui/material';
import ClientCard from '../components/cards/ClientCard';

const ClientModalContext = createContext(null);

export const useClientModal = () => {
  const ctx = useContext(ClientModalContext);
  if (!ctx) return { openClientModal: () => {} };
  return ctx;
};

export const ClientModalProvider = ({ children, onAddToLayout }) => {
  const [state, setState] = useState({ open: false, client: null });

  const openClientModal = useCallback((client) => {
    setState({ open: true, client });
  }, []);

  const closeClientModal = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  const handleAddToLayout = useCallback(() => {
    closeClientModal();
    if (onAddToLayout && state.client) onAddToLayout(state.client);
  }, [state.client, onAddToLayout, closeClientModal]);

  return (
    <ClientModalContext.Provider value={{ openClientModal }}>
      {children}
      <Dialog
        open={state.open}
        onClose={closeClientModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible' } }}
      >
        {state.client && (
          <ClientCard
            client={state.client}
            id={`modal_client_${state.client.client_id || state.client.client_name}`}
            onClose={closeClientModal}
            disableDragging
            onAddToLayout={onAddToLayout ? handleAddToLayout : undefined}
          />
        )}
      </Dialog>
    </ClientModalContext.Provider>
  );
};
